// extracted by mini-css-extract-plugin
export default {"BodyContainer":"_BodyContainer--QHfHx","BodyContainerText":"_BodyContainerText--LnWdR","WarningIcon":"_WarningIcon--WinQZ","Heading":"_Heading--CXf1U"};